export const WidthConstants = {
  quizContainerMaxWidth: "500px",
  quizContainerMaxWidthTablet: "550px",
};
